import React from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./privacy.css";
import { 
  FaShieldAlt, 
  FaUserLock, 
  FaDatabase, 
  FaLock, 
  FaTrashAlt, 
  FaChild, 
  FaSyncAlt, 
  FaEnvelope, 
  FaPhoneAlt,
  FaCheckCircle
} from "react-icons/fa";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-page-wrapper">
      <Nav />
      <Navbar />

      {/* Redesigned Privacy Hero Section */}
      <section className="privacy-hero-banner">
        <div className="privacy-hero-overlay">
          <div className="privacy-hero-container">
            <h1 className="hero-title">Privacy Policy &amp; Terms of Service</h1>
            <p className="hero-subtitle">
              Learn how Sangit Shree Prakashan protects your personal information, safeguards your privacy, and ensures secure transactions.
            </p>
            <div className="hero-features-strip">
              <div className="hero-feature-item">
                <FaLock className="feat-icon" />
                <span>256-Bit SSL Encryption</span>
              </div>
              <div className="hero-feature-item">
                <FaShieldAlt className="feat-icon" />
                <span>No Third-Party Data Sharing</span>
              </div>
              <div className="hero-feature-item">
                <FaUserLock className="feat-icon" />
                <span>Full Account &amp; Data Control</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Card */}
      <main className="privacy-content-container">
        <div className="privacy-meta-banner">
          <div className="privacy-meta-badge">
            <FaCheckCircle /> Official Policy
          </div>
          <span>Last Updated: January 2025</span>
        </div>

        <p>
          This Privacy Policy explains how <strong>Sangit Shree Prakashan</strong> collects, uses, and safeguards your information when you visit our website and purchase musical publications.
        </p>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaDatabase /></div>
            <h2>Information We Collect</h2>
          </div>
          <p>We only collect essential details necessary to fulfill your orders and manage your account:</p>
          <ul className="privacy-list">
            <li><span className="bullet-dot"></span> Full Name and Delivery Address for courier shipping</li>
            <li><span className="bullet-dot"></span> Contact Email Address for order confirmations and tracking updates</li>
            <li><span className="bullet-dot"></span> Mobile Phone Number for courier delivery coordination</li>
            <li><span className="bullet-dot"></span> Order history and purchase invoices</li>
          </ul>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaUserLock /></div>
            <h2>How We Use Your Information</h2>
          </div>
          <ul className="privacy-list">
            <li><span className="bullet-dot"></span> To manage your user account and authentic session</li>
            <li><span className="bullet-dot"></span> To process, pack, and ship your ordered books across India</li>
            <li><span className="bullet-dot"></span> To send automated dispatch, SMS, and WhatsApp tracking alerts</li>
            <li><span className="bullet-dot"></span> To provide prompt customer support and resolve delivery queries</li>
          </ul>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaShieldAlt /></div>
            <h2>Data Sharing Policy</h2>
          </div>
          <div className="privacy-highlight-box">
            We strictly do <strong>not</strong> sell, rent, or share your personal data with any third-party advertisers, marketing agencies, or external brokers. Your details are strictly utilized for direct order fulfillment and shipping services.
          </div>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaLock /></div>
            <h2>Data Security &amp; Payment Safety</h2>
          </div>
          <p>
            All network communication is protected via industry-standard SSL encryption. Payment transactions are processed directly through Razorpay's PCI-DSS compliant secure payment gateway. We never store debit/credit card numbers, CVVs, or bank net-banking passwords on our servers.
          </p>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaTrashAlt /></div>
            <h2>Account &amp; Data Deletion</h2>
          </div>
          <p>You may request deletion of your account and personal history at any time from your user profile:</p>
          <Link to="/profile" className="privacy-action-link">
            Manage Account &amp; Profile Settings &rarr;
          </Link>
          <p style={{ marginTop: "12px", fontSize: "0.88rem", color: "#64748b" }}>
            Upon receiving your request, your account and associated records will be permanently removed from our active database in accordance with data retention standards.
          </p>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaChild /></div>
            <h2>Children's Privacy</h2>
          </div>
          <p>
            Our services and literary purchases are intended for adult buyers, academic scholars, and supervised students. We do not knowingly collect personal information from minors under 18 years without parental consent.
          </p>
        </section>

        <section className="privacy-section">
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaSyncAlt /></div>
            <h2>Changes to This Policy</h2>
          </div>
          <p>
            We may occasionally update this Privacy Policy to reflect operational improvements or regulatory compliance. Continued use of our portal signifies acceptance of updated terms.
          </p>
        </section>

        <section className="privacy-section" style={{ marginBottom: 0 }}>
          <div className="privacy-section-header">
            <div className="privacy-section-icon"><FaEnvelope /></div>
            <h2>Contact &amp; Grievance Redressal</h2>
          </div>
          <p>If you have any questions or concerns regarding our privacy practices, please contact our administrative team:</p>
          <div className="contact-card-grid">
            <div className="contact-card-item">
              <FaEnvelope className="card-icon" />
              <div>
                <span>Official Email</span>
                <strong>sangitshreeprakashan@gmail.com</strong>
              </div>
            </div>
            <div className="contact-card-item">
              <FaPhoneAlt className="card-icon" />
              <div>
                <span>Direct Support</span>
                <strong>+91 7408452828</strong>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
